module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.15356/images/wordpress-authorization-connect.svg"